import { styled } from "styled-components";

export const LogoImage = styled.img`
  margin-left: 12px;
  width: 100px;
  height: 92px;
  border-radius: 50%;
`;
